import React from "react";

import SiteHead from "@/layouts/Head";
import Layout from "@/layouts/Layout";

const ServerError = () => {

    return (
		<React.Fragment>
			<SiteHead title="Server Error" />
			<Layout>
                <div className="notfound-container">
                    <h3 className="notfound-title">Sorry, an error occurred while trying to display this page.</h3>
                </div>
			</Layout>
		</React.Fragment>
	);
};

export default ServerError;

